
import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input } from "reactstrap";
import useRequests from '../../../Utils/useRequests';

const EditRulesToDigBy = ({ item, onClose }) => {
	const language = localStorage.getItem("I18N_LANGUAGE") || "eng";
	const { postRequest } = useRequests();
	const [loading, setLoading] = useState(false);
	const [title, setTitle] = useState(language === "sp" ? item?.title_sp : item?.title_eng || "");

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);
		const payload = {
			rtdb_id: item.rtdb_id,
			title,
			lang: item?.lang || localStorage.getItem("I18N_LANGUAGE") || "eng"
		};
		const res = await postRequest('update-rules-to-dig-by', JSON.stringify(payload));
		setLoading(false);
        onClose(res && res.code === 200 ? 'success' : 'error', res.message);
	};

	return (
		<Modal isOpen toggle={onClose}>
			<ModalHeader toggle={onClose}>
				Edit Rules To Dig By
			</ModalHeader>
			<Form onSubmit={handleSubmit}>
				<ModalBody>
					<FormGroup>
						<Label>Title</Label>
						<Input value={title} onChange={e => setTitle(e.target.value)} required />
					</FormGroup>
				</ModalBody>
				<ModalFooter>
					<Button color="primary" type="submit" disabled={loading}>
						{loading ? "Updating..." : "Update"}
					</Button>
					<Button color="secondary" onClick={onClose}>Cancel</Button>
				</ModalFooter>
			</Form>
		</Modal>
	);
};

export default EditRulesToDigBy;
